/* eslint-disable jsx-a11y/alt-text */
/*global kakao*/

import React, { Fragment, PureComponent } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

class StoreInfoMap extends PureComponent {
  componentDidMount = () => {
    const { store } = this.props.childProps;
    this._loadMap(store);
  };
  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    ////console.log(this.props.location.pathname)
    ////console.log(nextProps.location)
    return this.props.match.params.store !== nextProps.match.params.store;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    if (this.props.match.params.store !== nextProps.match.params.store) {
      this._loadMap(nextProps.match.params.store);
    }
  };
  _loadMap = (store) => {
    let xpos, ypos;
    if (store === 'hapjung') {
      xpos = 37.5510357;
      ypos = 126.911846;
    } else if (store === 'daejeon') {
      //X :127.424113, Y :36.3276385
      xpos = 36.3276385;
      ypos = 127.424113;
    } else if (store === 'gwangju') {
      //X :126.914677, Y :35.1480999
      xpos = 35.1480999;
      ypos = 126.914677;
    } else if (store === 'busan') {
      //X :129.059619, Y :35.1530254
      xpos = 35.1530254;
      ypos = 129.059619;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src =
      'https://dapi.kakao.com/v2/maps/sdk.js?appkey=bd220d9ba92eddd45bccfdf741f56ea2&autoload=false';
    document.head.appendChild(script);

    script.onload = () => {
      kakao.maps.load(() => {
        let container = document.getElementById('maps');
        //console.log(container)
        let options = {
          center: new kakao.maps.LatLng(xpos, ypos),
          level: 4,
        };

        const map = new window.kakao.maps.Map(container, options);

        let markerPosition = new kakao.maps.LatLng(xpos, ypos);
        let marker = new kakao.maps.Marker({
          position: markerPosition,
        });

        // 마커를 지도 위에 표시
        marker.setMap(map);
      });
    };
  };
  render() {
    const { store } = this.props.childProps;
    const { imgUrl } = this.props;
    return (
      <Fragment>
        <div className="store_mapArea">
          <div className="map">
            {/* * 카카오맵 - 지도퍼가기 */}
            {/* 1. 지도 노드 */}
            <div
              id="maps"
              className="root_daum_roughmap root_daum_roughmap_landing"
              style={{ width: 800, height: 800 }}
            ></div>
            {/*
                            2. 설치 스크립트
                            * 지도 퍼가기 서비스를 2개 이상 넣을 경우, 설치 스크립트는 하나만 삽입합니다.
                        */}
          </div>
          {store === 'hapjung' ? (
            <div className="map_navi">
              <dl>
                <dt>
                  <i>
                    <img src={imgUrl + '/img/store/ico_address.svg'} />
                  </i>
                  <span>주소</span>
                </dt>
                <dd>
                  서울특별시 마포구 월드컵로 3길 14 딜라이트 스퀘어 B101-105
                  <br />
                  <b>Tel) 070-7162-3000</b>
                </dd>
              </dl>
              <dl>
                <dt>
                  <i>
                    <img src={imgUrl + '/img/store/ico_metro.svg'} />
                  </i>
                  <span>지하철</span>
                </dt>
                <dd>
                  2호선/6호선 합정역 8번출구방향 건물 연결통로(에스컬레이터
                  이용하여) 지하로 이동. 교보문고 2차 키움 맞은편 위치.
                </dd>
              </dl>
              <dl>
                <dt>
                  <i>
                    <img src={imgUrl + '/img/store/ico_bus.svg'} />
                  </i>
                  <span>버스</span>
                </dt>
                <dd>
                  271, 7011, 7013A, 7013B, 730 탑승 후 ‘합정역 마포한강푸르지오’
                  앞 하차 또는 합정역 도착하는 버스 이용하여 ‘합정역’하차하여
                  마포한강푸르지오2차 지하1층 공차 맞은편 위치.
                </dd>
              </dl>
              <dl>
                <dt>
                  <i>
                    <img src={imgUrl + '/img/store/ico_car.svg'} />
                  </i>
                  <span>자가용</span>
                </dt>
                <dd>
                  마포한강2차푸르지오 지하주차장 이용. 1만원 구매 시마다 30분
                  할인, 최대 4시간까지 가능
                </dd>
              </dl>
            </div>
          ) : store === 'daejeon' ? (
            <div className="map_navi">
              <dl>
                <dt>
                  <i>
                    <img src={imgUrl + '/img/store/ico_address.svg'} />
                  </i>
                  <span>주소</span>
                </dt>
                <dd>
                  대전시 중구 중앙로 126 청청빌딩 4층
                  <br />
                  <b>Tel) 070-7162-7046</b>
                </dd>
              </dl>
              <dl>
                <dt>
                  <i>
                    <img src={imgUrl + '/img/store/ico_metro.svg'} />
                  </i>
                  <span>지하철</span>
                </dt>
                <dd>
                  1호선 중앙로 역 하차. 지하상가 통로 이용하여 B-8 출구로
                  나오시면 바로 앞 메가박스 건물 4층에 위치.
                </dd>
              </dl>
              <dl>
                <dt>
                  <i>
                    <img src={imgUrl + '/img/store/ico_bus.svg'} />
                  </i>
                  <span>버스</span>
                </dt>
                <dd>
                  201번/ 701번/ 622번 탑승 후 ‘중앙로 역 6번 출구’ 하차. 건너편
                  메가박스 건물 4층에 위치.
                </dd>
              </dl>
              <dl>
                <dt>
                  <i>
                    <img src={imgUrl + '/img/store/ico_car.svg'} />
                  </i>
                  <span>자가용</span>
                </dt>
                <dd>
                  메가박스 건물 지하 주차장 이용. 3만 원 이상 구매 시 1시간 30분
                  주차 할인 가능.
                </dd>
              </dl>
            </div>
          ) : store === 'gwangju' ? (
            <div className="map_navi">
              <dl>
                <dt>
                  <i>
                    <img src={imgUrl + '/img/store/ico_address.svg'} />
                  </i>
                  <span>주소</span>
                </dt>
                <dd>
                  광주시 동구 충장로안길 12
                  <br />
                  <b>Tel) 070-7162-7047</b>
                </dd>
              </dl>
              <dl>
                <dt>
                  <i>
                    <img src={imgUrl + '/img/store/ico_metro.svg'} />
                  </i>
                  <span>지하철</span>
                </dt>
                <dd>
                  1호선 금남로 4가 역에서 충금 지하상가를 통해 롯데시네마
                  방면으로 약 300m 이동 후 지상으로 올라와 첫 번째 골목길로 120m
                  이동하시면 왼쪽에 롯데시네마 충장로점 바로 옆에 위치.
                </dd>
              </dl>
              <dl>
                <dt>
                  <i>
                    <img src={imgUrl + '/img/store/ico_bus.svg'} />
                  </i>
                  <span>버스</span>
                </dt>
                <dd>
                  금남 59번/수완 12번/지원 45번/금남 55번/송암 74번 탑승, “충장
                  치안센터” 정류장 하차 &gt; 약 120m 이동 롯데시네마 충장로점
                  바로 옆에 위치.
                </dd>
              </dl>
              <dl>
                <dt>
                  <i>
                    <img src={imgUrl + '/img/store/ico_car.svg'} />
                  </i>
                  <span>자가용</span>
                </dt>
                <dd>주차장이 없습니다. 주자 할인이 불가능합니다. </dd>
              </dl>
            </div>
          ) : store === 'busan' ? (
            <div className="map_navi">
              <dl>
                <dt>
                  <i>
                    <img src={imgUrl + '/img/store/ico_address.svg'} />
                  </i>
                  <span>주소</span>
                </dt>
                <dd>
                  부산시 부산진구 중앙대로 672 삼정타워 9층
                  <br />
                  <b>Tel) 070-7162-7048</b>
                </dd>
              </dl>
              <dl>
                <dt>
                  <i>
                    <img src={imgUrl + '/img/store/ico_metro.svg'} />
                  </i>
                  <span>지하철</span>
                </dt>
                <dd>
                  1호선, 2호선 서면역 2번출구 방향 지하상가 통로를 이용하여
                  끝까지 이동. 계단으로 지상 출구로 나온후. 나온 방향으로
                  직진하여 도보 3분거리에 위치한 삼정타워 건물 9층에 위치.
                </dd>
              </dl>
              <dl>
                <dt>
                  <i>
                    <img src={imgUrl + '/img/store/ico_bus.svg'} />
                  </i>
                  <span>버스</span>
                </dt>
                <dd>
                  67, 68, 108, 138, 160, 167, 168, 169-1, 1002, 1004번 탑승 후
                  "서면 한전 앞"하차 후 횡단보도 이용. 1층 ‘스타벅스’가 입점한
                  삼정타워 건물9층에 위치
                </dd>
              </dl>
              <dl>
                <dt>
                  <i>
                    <img src={imgUrl + '/img/store/ico_car.svg'} />
                  </i>
                  <span>자가용</span>
                </dt>
                <dd>
                  삼정타워 지하주차장 이용. 구매금액 1만원-1시간 / 3만원-2시간 /
                  5만원-3시간 / 10만원-4시간/ 20만원-5시간 할인, 최대 5시간까지
                  가능
                </dd>
              </dl>
            </div>
          ) : null}
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(React.memo(StoreInfoMap)));
